import React, { useState, useEffect } from 'react';
import { drillsService } from '../../../services/drillsService';

export default function DrillFilters({ filters, onFiltersChange }) {
  const [industries, setIndustries] = useState([]);
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadFilterOptions();
  }, []);

  const loadFilterOptions = async () => {
    try {
      const [industriesData, typesData] = await Promise.all([
        drillsService?.getIndustries(),
        drillsService?.getTypes()
      ]);
      setIndustries(industriesData);
      setTypes(typesData);
    } catch (err) {
      console.error('Error loading filter options:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (filterName, value) => {
    onFiltersChange({
      ...filters,
      [filterName]: value
    });
  };

  const clearFilters = () => {
    onFiltersChange({
      industry: '',
      type: '',
      difficultyLevel: ''
    });
  };

  const hasActiveFilters = filters?.industry || filters?.type || filters?.difficultyLevel;

  if (loading) {
    return (
      <div className="bg-white rounded-lg p-4 mb-6 border border-slate-200">
        <p className="text-slate-600">Loading filters...</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg p-6 mb-6 border border-slate-200">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-semibold text-slate-800">Filters</h2>
        {hasActiveFilters && (
          <button
            onClick={clearFilters}
            className="text-sm text-blue-600 hover:text-blue-700 font-medium"
          >
            Clear All
          </button>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Industry Filter */}
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">
            Industry
          </label>
          <select
            value={filters?.industry}
            onChange={(e) => handleFilterChange('industry', e?.target?.value)}
            className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">All Industries</option>
            {industries?.map(industry => (
              <option key={industry} value={industry}>
                {industry}
              </option>
            ))}
          </select>
        </div>

        {/* Type Filter */}
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">
            Type
          </label>
          <select
            value={filters?.type}
            onChange={(e) => handleFilterChange('type', e?.target?.value)}
            className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">All Types</option>
            {types?.map(type => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>

        {/* Difficulty Filter */}
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">
            Difficulty
          </label>
          <select
            value={filters?.difficultyLevel}
            onChange={(e) => handleFilterChange('difficultyLevel', e?.target?.value)}
            className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">All Levels</option>
            <option value="1">Beginner (1)</option>
            <option value="2">Intermediate (2)</option>
            <option value="3">Advanced (3)</option>
            <option value="4">Expert (4)</option>
            <option value="5">Master (5)</option>
          </select>
        </div>
      </div>
    </div>
  );
}